/* ============
 * Actions for the cvc module
 * ============
 *
 * The actions that are available on the
 * cvc module.
 */
import axios from 'axios'

export default {
  getPaymentQuotes ({commit, dispatch}, data) {
    let api = process.env.API_URL_V2
    if (!(data || {}).policies || (data.policies || []).length === 0) {
      return new Promise((resolve, reject) => {
        reject(new Error('No tiene polizas disponibles'))
      })
    }
    const all = data.policies.map(policy => {
      return new Promise((resolve, reject) => {
        const requestData = { policies: [policy] }
        axios.post(api + 'payment-quotes/policies', requestData)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        let response = {}
        let first = true
        Promise.all(all).then(res => {
          res.forEach((result) => {
            if (first) {
              first = false
              response = { ...result }
            } else {
              response.data.fails = { ...response.data.fails, ...result.data.fails }
              response.data.paymentsHistory = { ...response.data.paymentsHistory, ...result.data.paymentsHistory }
              response.data.policies = { ...response.data.policies, ...result.data.policies }
            }
          })
          resolve(response)
        })
      })
    })
  },
  paymentQuotes ({commit, dispatch}, data) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        // axios.post('http://localhost:8003/api-zonasegura/v2/payment-quotes/pay' || api, data)
        axios.post(api + 'payment-quotes/payments', data)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  pagoEfectivo ({commit, dispatch}, data) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        // axios.post('http://localhost:8003/api-zonasegura/v2/payment-quotes/pago-efectivo' || api, data)
        axios.post(api + 'payment-quotes/cash-payments', data)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  async getIP () {
    let api = process.env.GET_IP
    return new Promise((resolve, reject) => {
      axios.get(api)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPaymentCardsByClient ({ dispatch }, item) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'payments/cards', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  // Delegado en la sesión de CR Auth (user/ensureSession); nunca rechaza, igual que antes
  checkJWT ({ dispatch }) {
    return dispatch('user/checkJWT', null, { root: true })
  },
  sendMail ({ dispatch }, item) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'payment-quotes/emails', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payments/actions.js